import { stateSegments } from "../lib/filters";

/** "Waiting for the SME" to "waiting for the SME": only the first letter goes down. */
function lower(label: string): string {
  return label.charAt(0).toLowerCase() + label.slice(1);
}

/** A bar that shows a file's elements by state. Colour is for state only, and the words are always there. */
export function StateBar({ states, label, empty = "Nothing in it yet" }: { states: Record<string, number>; label?: string; empty?: string }) {
  const segments = stateSegments(states);
  const total = segments.reduce((sum, segment) => sum + segment.count, 0);
  if (total === 0) return <span className="muted">{empty}</span>;
  const words = segments.map((segment) => `${segment.count} ${lower(segment.label)}`).join(", ");
  return (
    <span className="state-bar" role="img" aria-label={label ? `${label}: ${words}` : words}>
      {segments.map((segment) => (
        <span key={segment.tone} className="state-bar__part" data-state={segment.tone} style={{ width: `${segment.share}%` }} title={`${segment.count} ${lower(segment.label)}`} />
      ))}
    </span>
  );
}
